import { BlockViewModel } from '../../ViewModels/BlockViewModel/BlockViewModel';

export class PermissionsManager {
  private Data: Editor.Data.API;
  private Visualizer: Editor.Visualizer.State;

  constructor(dataManager: Editor.Data.API, Visualizer: Editor.Visualizer.State) {
    this.Data = dataManager;
    this.Visualizer = Visualizer;
    this.handlePermissionsSummaryChanged = this.handlePermissionsSummaryChanged.bind(this);
  }

  start() {
    this.Data.events.on('LOAD_PERMISSIONS_SUMMARY', this.handlePermissionsSummaryChanged);
  }

  private handlePermissionsSummaryChanged(summary: Permissions.PermissionSummary) {
    //
    let children = this.Visualizer.dVM?.children;
    let childrenList = children?.list() || [];
    let child;
    for (let index = 0; index < childrenList.length; index++) {
      child = childrenList[index];
      (child as BlockViewModel).setBlockSelected(
        this.Data.permissions.isSelectedForPermissions(child.id),
      );
    }
  }

  destroy() {
    this.Data.events.off('LOAD_PERMISSIONS_SUMMARY', this.handlePermissionsSummaryChanged);
  }
}
